<nb-card [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Importando informes ...">
  <nb-card-header>
      <h3>Importador de reportes</h3>
  </nb-card-header>
  <nb-card-body>
      <div class="row mb-3">
        <div class="col-8">
        <!--
          <nb-select [placeholder]="tipoInformePlaceholder" fullWidth name="role" [(ngModel)]="tipoInformeSeleccionado">
            <nb-option [value]="item.id" *ngFor="let item of tiposInforme">{{item.name}}</nb-option>
          </nb-select>
        -->
          <angular2-multiselect [data]="tiposInforme" 
          [(ngModel)]="tipoInformeSeleccionado" 
          [settings]="settings">
        </angular2-multiselect>          
        </div>
        <div class="col-4">
          <button [disabled]="tipoInformeSeleccionado == null" nbButton fullWidth status="primary" (click)="generarExcel()">Generar Excel</button>
        </div>

      </div>



      <div class="row" >
        <div class="col-8">
          <div class="form-group">

            <input type="file" nbInput fullWidth id="excel" name="excel"  (change)="actualizarArchivo($event.target.files)"/>
          </div>
        </div>
        <div class="col-4">
          <button [disabled]="tipoInformeSeleccionado == null || archivo == null" fullWidth nbButton status="primary" (click)="importarExcel()">Importar Excel</button>
        </div>
      </div>
      <div class="row p-3" *ngIf="importError">
        <div class="col-12">
          <p><strong>Errores al importar el conjunto de informes:</strong></p>
          <p *ngFor="let item of importError">
            {{item}}
          </p>
        </div>

      </div>
    </nb-card-body>

</nb-card>
